import type { MoneyModel } from 'shared/ui/FormatMoney';
import type { LastWeekBudgetModel, WeeklyBudgetModel } from 'entities/campaign/@x';
import type { ManagerModel } from 'entities/manager/@x';
import type { SalesRep } from 'entities/sales-rep/@x';
import type { Timezone } from 'shared/lib/timezones';
import type { CapitalizedPaymentFrequency, Payment, PaymentFrequency } from 'shared/lib/payment';

export interface ImpersonateTokenModel {
  data: {
    token: string;
  };
}

export const PAYMENT_FREQUENCY_OPTIONS: { text: CapitalizedPaymentFrequency; id: PaymentFrequency }[] = [
  { text: 'Weekly', id: 'weekly' },
  { text: 'Bi-Weekly', id: 'bi-weekly' },
  { text: 'Monthly', id: 'monthly' },
];

export interface ContractorModel {
  id: number;
  companyName: string;
  lastWeekBudget: LastWeekBudgetModel;
  manager: {
    fullName: string;
  } | null;
  salesRepresentative: {
    fullName: string;
  } | null;
  totalSpent: MoneyModel;
  weeklyBudget: WeeklyBudgetModel;
  fullName: string;
}

export interface CreateContractorDataModel {
  fullName: string;
  companyName: string;
  phoneNumber: string;
  email: string;
  website: string;
  timezone: Timezone;
  managerId: number | null;
  salesRepId: number | null;
  hubspotCompanyId: string;
  paymentMethod: Payment;
}

export interface GetContractorModel {
  id: number;
  fullName: string;
  companyName: string;
  phoneNumber: string;
  email: string;
  website: string;
  timezone: Timezone;
  manager: null | ManagerModel;
  salesRep: null | SalesRep;
  hubspotCompanyId?: string;
  paymentMethod: Payment;
  createdAt: string;
  hasCards: boolean;
  paymentFrequency: PaymentFrequency;
  campaignCounters: {
    leadTypeCount: number;
    appointmentTypeCount: number;
    salesTypeCount: number;
  };
  dbas: DBAs;
}

export interface PromoPayloadModel {
  from: MoneyModel | null;
  to: MoneyModel | null;
  statusLastUpdated: string | null;
}

export enum PromoStatusModel {
  running = 'running',
  pending = 'pending',
  finished = 'finished',
}

export interface DBA {
  name: string;
  id: number;
}

export type DBAs = DBA[];

export interface ContractorPromoModel {
  id: number;
  service: {
    id: number;
    name: string;
  };
  status: PromoStatusModel;
  budget: MoneyModel;
  spentBudget: MoneyModel;
  launchBudget: MoneyModel;
  spent: MoneyModel;
  payload?: PromoPayloadModel;
}

export interface ContractorAvailablePromoModel {
  id: number;
  name: string;
}

export interface ContractorActivePromosModel {
  hasAvailable: boolean;
  additivePromos: string | null;
  active: ContractorPromoModel[];
  cdPromosCount: number;
}

export enum PromoTypes {
  first_vertical = 'First',
  second_vertical = 'Second',
  third_vertical = 'Third',
}
